/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */
import './BrokerageAccountDetails.scss';

import { number, object, string } from 'prop-types';
import React, { useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getAccountForDetails,
  getAccountDetailsId,
  getAccountDetailsInvestment,
  getAccountOwners,
  getNumberOfAccountsForSelection
} from 'state/account/AccountSelectors';
import { withOtelContext } from '@trp-ta-nitro/otel-react';
import AccountDetailsHeader from 'components/layouts/AccountDetails/AccountDetailsHeader';
import { PageHeader } from 'components/pages/Header/PageHeader';
import Store from 'state/Store';
import {receivedBrokerageLogin, updateBrokerageMFEState} from 'state/brokerage/BrokerageActions';
import {getPershingJWT, resetBrokerageMFE} from 'services/Rest';
import {getBrokerageMFELogin, getBrokerageMFEState} from 'state/brokerage/BrokerageSelectors';
import { getLdapId } from 'state/customer/CustomerSelectors';
import PageLoadingSpinner from 'components/layouts/Navigation/PageLoadingSpinner';
import ErrorPage from 'components/shared/ErrorPage/ErrorPage';
import AccountDetailsCTA from './AccountDetailsCTA';
import {MFE_STATE} from "support/BrokerageMFEUtils";

const BrokerageAccountDetails = ({
  account,
  accountDetailsId,
  accountDetailsInvestment,
  mfeLoggedIn,
  ldapId,
  history,
  accountOwners,
  numberOfAccounts,
  MFEState
}) => {
  useEffect(() => {
    resetBrokerageMFE();
  }, []);

  useEffect(() => {
    if (accountDetailsId === null) {
      history.push('/accounts');
    }
  }, [accountDetailsId, history]);

  useEffect(() => {
    if(account) {
      const brokerageAccount = `${account?.accountNumber}${account?.accountChecksum}`;
      if (brokerageAccount && window.pershingMFEHelper) {
        Store.dispatch(updateBrokerageMFEState(MFE_STATE.LOADING));
        setTimeout(() => {
          window.pershingMFEHelper.setAccount(brokerageAccount);
        });
      }
    }
  }, [accountDetailsInvestment]);

  useEffect(() => {
    if(MFEState === MFE_STATE.LOADING) {
      Store.dispatch(updateBrokerageMFEState(MFE_STATE.LOADED));
    }
  }, [MFEState]);

  const handleEvents = (event) => {
    if (event.msgid === 'PERMFE003') {
      // successful login
      Store.dispatch(receivedBrokerageLogin(true));
    }
    // Renew token event
    if (event.msgid === 'PERMFE007') {
      getPershingJWT(true, ldapId);
    }
    // Login Error
    if (event.msgid === 'PERMFE004') {
      Store.dispatch(updateBrokerageMFEState(MFE_STATE.ERROR));
    }
    //MFE Loading event
    if (event.msgid === 'PERMFE011') {
      if (event.text.includes('Loaded Module @pershing/nxi-ng-holdings')) {
        Store.dispatch(updateBrokerageMFEState(MFE_STATE.LOADED));
        // Setting the MFE to default to a specific account
        const brokerageAccount = `${account.accountNumber}${account.accountChecksum}`;
        if (brokerageAccount) {
          setTimeout(() => {
            window.pershingMFEHelper.setAccount(brokerageAccount);
          });
        }
      }
    }
  };

  useEffect(() => {
    if (window && window.pershingMFEHelper && ldapId) {
      window.pershingMFEHelper.getPershingMFEEvents(handleEvents);
      if (mfeLoggedIn) {
        // Load the required MFE Modules form pershing
        window.pershingMFEHelper.loadModules(['nxi-ng-holdings']);
      } else {
        //Get the JWT token from the Pershing API
        getPershingJWT(false, ldapId);
      }
    }
  }, [mfeLoggedIn, ldapId]);

  if (MFEState === MFE_STATE.LOADING) {
    return <PageLoadingSpinner name="Brokerage Account Details" />;
  }
  return MFEState === MFE_STATE.ERROR ? (
    <div className="brokerage-accountHolding-details-error-page--container">
      <ErrorPage />
    </div>
  ) : (
    <div className="brokerage-accountHolding-details">
      <PageHeader title="Account Details" />
      {account && (
        <AccountDetailsHeader
          account={account}
          numberOfAccounts={numberOfAccounts}
          owners={accountOwners}
          positions={account?.positions || []}
          currentCusip={accountDetailsInvestment}
        />
      )}
      <AccountDetailsCTA />
      <holdings-grid-app
        class="per-mfe-ns"
        is-navigation-acct-profile-enabled="false"
        is-actions-col-enabled="false"
        is-market-link-enabled="false"
        cusip={accountDetailsInvestment}></holdings-grid-app>
    </div>
  );
};

BrokerageAccountDetails.propTypes = {
  history: object.isRequired,
  account: object.isRequired,
  accountOwners: string.isRequired,
  numberOfAccounts: number.isRequired
};

const mapStateToProps = (state) => {
  return {
    account: getAccountForDetails(state),
    accountOwners: getAccountOwners(state),
    numberOfAccounts: getNumberOfAccountsForSelection(state),
    accountDetailsId: getAccountDetailsId(state),
    accountDetailsInvestment: getAccountDetailsInvestment(state),
    mfeLoggedIn: getBrokerageMFELogin(state),
    ldapId: getLdapId(state),
    MFEState: getBrokerageMFEState(state),
  };
};

export default compose(
  withRouter,
  withOtelContext,
  connect(mapStateToProps)
)(BrokerageAccountDetails);
